<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      show-save-button
      unit="人员信息"
      id-key="TeacherId"
      :data="data"
      form-label-width="95px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')" 
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="人员编号" prop="TeacherNumber">
              <el-input size="mini" v-model="data.TeacherNumber" placeholder="请填写人员编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="姓名" prop="TeacherName">
              <el-input size="mini" v-model="data.TeacherName" placeholder="请填写姓名"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="isMB?24:12">
            <el-form-item label="验证码" prop="VerificationCode">
              <el-input
                size="mini"
                v-model="data.VerificationCode"
                type="number"
                placeholder="请填写4位验证码"
              ></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="isMB?24:12">
            <el-form-item label="手机号码" prop="PhoneNumber">
              <el-input size="mini" v-model="data.PhoneNumber" type="number" placeholder="请填写手机号码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="职务" prop="JobIds">
              <el-select
                v-model="data.JobIds"
                multiple
                placeholder="请选择"
                style="width: 100%"
                size="mini"
              >
                <el-option
                  v-for="item in jobList"
                  :key="item.JobId"
                  :label="item.JobName"
                  :value="item.JobId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item label="公众号OpenId">
              <el-input size="mini" v-model="data.WxPublicId" placeholder="请填写OpenId"></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import jobApi from "@/api/fa/job";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        TeacherId: 0,
        TeacherNumber: "",
        TeacherName: "",
        // VerificationCode: "",
        PhoneNumber: "",
        // WxPublicId: null,
        JobIds: [],
      },
      api: require("@/api/fa/teacher").default,
      jobApi,
      isMB: this.$store.state.isMB,
      jobList: [],
      rules: {
        TeacherNumber: [{ required: true, message: "请填写教师编号" }],
        TeacherName: [{ required: true, message: "请填写姓名" }],
        // VerificationCode: [{ required: true, message: "请填写4位验证码" }],
        JobIds: [{ required: true, message: "请选择职务" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.getOption();
    },
    onEditOpened() {
      this.getOption();
    },
    getOption() {
      this.jobApi.list({}).then((res) => {
        this.jobList = res.Data;
      });
    },
    onBeforeSave() {
      // if (
      //   !(
      //     this.data.VerificationCode >= 0 &&
      //     this.data.VerificationCode % 1 == 0 &&
      //     this.data.VerificationCode.length == 4
      //   )
      // ) {
      //   this.$message.error("验证码需为4位整数");
      //   return false;
      // }
    },
  },
};
</script>
<style lang="scss">
</style>